(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-with-video-background"] && !Shopify.designMode) return;
  try {
    
const formatHeroSocialCounts = () => {
  document.querySelectorAll('[data-social-count]').forEach(element => {
    if (element.dataset.formatted) return;
    const count = Number(element.textContent.trim());
    if (!Number.isFinite(count)) return;
    element.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en').format(count);
    element.dataset.formatted = 'true';
  });
};
formatHeroSocialCounts();
document.addEventListener('shopify:section:load', formatHeroSocialCounts);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-collections-redesign"]) return;
  try {
    
(function(){function init(root){if(root.dataset.smcReady)return;root.dataset.smcReady='true';root.classList.add('smc-ready');const controls=root.querySelector('[data-smc-filters]');controls.hidden=false;const input=root.querySelector('[data-smc-search]');const cards=Array.from(root.querySelectorAll('[data-smc-card]'));let active='all';function filter(){const term=input.value.trim().toLowerCase();let count=0;cards.forEach(card=>{const show=(active==='all'||card.dataset.group===active)&&card.dataset.search.includes(term);card.hidden=!show;if(show)count++});root.querySelector('.smc-empty').hidden=count!==0;}input.addEventListener('input',filter);controls.addEventListener('click',event=>{const button=event.target.closest('[data-smc-filter]');if(!button)return;active=button.dataset.smcFilter;controls.querySelectorAll('button').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));filter()})}document.querySelectorAll('.smc').forEach(init);document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('.smc').forEach(init))})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-shop-browser"]) return;
  try {
    
function initStencilBrowse(root){
  root.querySelectorAll('.smb').forEach(section=>{
    if(section.dataset.initialized)return;
    section.dataset.initialized='true';
    const menu=section.querySelector('.smb-menu');
    const mobile=window.matchMedia('(max-width:900px)');
    const sync=()=>{menu.open=!mobile.matches;};
    sync();mobile.addEventListener('change',sync);
    menu.addEventListener('keydown',event=>{if(event.key==='Escape'&&mobile.matches){menu.open=false;menu.querySelector('summary').focus();}});
    const form=section.querySelector('.smb-sort');
    if(form){form.classList.add('smb-enhanced');form.querySelector('select').addEventListener('change',()=>{const url=new URL(form.action,location.origin);const preview=new URLSearchParams(location.search).get('preview_theme_id');if(preview)url.searchParams.set('preview_theme_id',preview);url.searchParams.set('sort_by',form.querySelector('select').value);location.assign(url.href);});}
  });
}
initStencilBrowse(document);
document.addEventListener('shopify:section:load',event=>initStencilBrowse(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["you-may-also-like"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.ymal-section').forEach(function(section){
  var track   = section.querySelector('.ymal-track');
  var prevBtn = section.querySelector('.ymal-arrow--prev');
  var nextBtn = section.querySelector('.ymal-arrow--next');
  if (!track || !prevBtn || !nextBtn) return;

  function step(){
    var card = track.querySelector('.ymal-card');
    if (!card) return 300;
    var gap = parseFloat(getComputedStyle(track).gap) || 0;
    return card.getBoundingClientRect().width + gap;
  }

  function updateArrows(){
    var maxScroll = track.scrollWidth - track.clientWidth - 1;
    prevBtn.classList.toggle('is-disabled', track.scrollLeft <= 0);
    nextBtn.classList.toggle('is-disabled', track.scrollLeft >= maxScroll);
  }

  prevBtn.addEventListener('click', function(){
    track.scrollBy({ left: -step(), behavior: 'smooth' });
  });
  nextBtn.addEventListener('click', function(){
    track.scrollBy({ left: step(), behavior: 'smooth' });
  });

  track.addEventListener('scroll', updateArrows, { passive: true });
  window.addEventListener('resize', updateArrows);
  updateArrows();
});

  } catch(e) { console.error(e); }
})();
})();
